import styled from 'styled-components';
import React from 'react';
import { devices, theme } from '@/styles/theme/index.jsx';
import Image from 'next/image';

const LogoBox = ({ imgPath, title }) => {
	return (
		<StyledLogoBox className="single-item-logo-partners">
			<div className="logo-wrapper">
				<Image  loading="lazy" width={'135'} height={'135'} objectFit={'contain'}   src={imgPath} alt={title ? title : 'Logo - Eco Sourcing Limited'} />
			</div>
		</StyledLogoBox>
	);
};

const StyledLogoBox = styled.div`
    border: 1px solid ${theme.colors.white};
    position: relative;
    padding-top: ${theme.logoRatio};
    transition: ${theme.transition};
    ${theme.flexCenter}
    img {
        object-fit: contain;
        ${theme.transformMiddle}
        transition: ${theme.transition};
        ${devices.lgMd} {
            padding: 10px;
        }
        ${devices.md} {
            padding: 10px;
        }
		
    }

    &:hover {
        background: ${theme.colors.white};
        img {
            filter: invert(1);
        }
    }



`;
export default LogoBox;
